import { ChangeDetectionStrategy, Component, Input, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import * as fromRoot from '@core/redux/index';
import * as LayoutAction from '@core/redux/layout/layout.actions';
import { Store } from '@ngrx/store';
import { AvatarComponent } from '@ux/components/avatar/avatar.component';
import { UserMenuComponent } from '@ux/components/user-menu/user-menu.component';
import { NgClickOutsideDelayOutsideDirective } from 'ng-click-outside2';

import { BurgerComponent } from '../burger/burger.component';
import { FastSearchComponent } from '../fast-search/fast-search.component';
import { MenuComponent } from '../menu/menu.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less'],
  imports: [
    FastSearchComponent,
    MenuComponent,
    AvatarComponent,
    UserMenuComponent,
    BurgerComponent,
    NgClickOutsideDelayOutsideDirective,
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  private readonly store = inject(Store<fromRoot.State>);

  @Input({ required: true }) isShowSidebar!: boolean;

  protected readonly user = toSignal(this.store.select(fromRoot.getUser), {
    initialValue: null,
  });
  protected readonly isOpenMenu = signal(false);

  protected onToggleSidebar(): void {
    this.store.dispatch(new LayoutAction.OpenSidebar());
  }

  protected onToggleMenu(event: Event): void {
    event.stopPropagation();
    event.preventDefault();
    this.isOpenMenu.update(current => !current);
  }

  protected onClose(): void {
    this.isOpenMenu.set(false);
  }
}
